// SPLIDE MOBILE
document.addEventListener('DOMContentLoaded', function () {
  var splideElems = document.querySelectorAll('.splide-marquee-co');

  splideElems.forEach(function(splideElem) {
      var splide = new Splide(splideElem, {
          type: 'loop',
          arrows: true,
          pagination: false,
          perPage: 3,
          perMove: 1,
          gap: 0,
          omitEnd: true,
          breakpoints: {
            1000: {
              perPage: 2
          },
              768: {
                  perPage: 1,
                  arrows: true,
                  pagination: false,
                  fixedWidth: '100%',
                  perMove: 1,
                  padding: {
                      left: 15,
                      right: 15
                  }
              }
          }
      }).mount();
  });
});



// KILLIAN
// Déclaration Splitting
Splitting();

//scrollTrigger plugin registration
gsap.registerPlugin(ScrollTrigger);

// Définition d'une fonction pour initialiser ou réinitialiser les animations
function initSliderAnimations() {
  // Tuer tous les ScrollTriggers existants pour éviter les doublons
  ScrollTrigger.getAll().forEach((trigger) => trigger.kill());

  const sliderCategory = document.querySelectorAll(".slider-category");

  sliderCategory.forEach((slider) => {
    // Animation du titre
    gsap.to(slider.querySelector(".title-banner .title-text"), {
      left: "13%",
      scrollTrigger: {
        trigger: slider.querySelector(".title-banner .title-text"),
        start: "top center+=20%",
        end: "bottom+=20% top",
        scrub: true
      }
    });
  });
}

// Appel initial de la fonction pour démarrer les animations
initSliderAnimations();

document.addEventListener("DOMContentLoaded", function() {
  // Sélectionnez tous les éléments .mm-cc-container
  const ccContainers = document.querySelectorAll('.mm-cc-container');

  // Gérer le hover sur chaque élément .mm-cc-container
  ccContainers.forEach(function(container) {
    container.addEventListener('mouseenter', function() {
      // Lorsque la souris entre dans l'élément, assurez-vous que son opacity reste à 1
      this.style.opacity = '1';

      // Baisser l'opacity des autres éléments
      ccContainers.forEach(function(otherContainer) {
        if (otherContainer !== container) {
          otherContainer.style.opacity = '0.5';
        }
      });
    });

    container.addEventListener('mouseleave', function() {
      // Lorsque la souris quitte l'élément, vérifiez si aucun élément n'est survolé.
      const isHovered = Array.from(ccContainers).some(function(otherContainer) {
        return otherContainer.matches(':hover');
      });

      // Si aucun élément n'est survolé, rétablissez l'opacity à 1 pour tous les éléments
      if (!isHovered) {
        ccContainers.forEach(function(otherContainer) {
          otherContainer.style.opacity = '1';
        });
      }
    });
  });
});
